export enum DYNAMIC_FORM_TYPES {
  MAIL_A_CHECK= 'MAIL_A_CHECK',
  ACH_OUT = 'ACH_OUT',
  BILL_PAY = 'BILL_PAY',
  ACH_OUT_MANDATORY = 'ACH_OUT_MANDATORY',
  ACCOUNTANT = 'ACCOUNTANT',
  WIRE_OUT = 'WIRE_OUT',
  WIRE_OUT_MANDATORY = 'WIRE_OUT_MANDATORY',
}

export type formTypes = DYNAMIC_FORM_TYPES.WIRE_OUT_MANDATORY | DYNAMIC_FORM_TYPES.WIRE_OUT | DYNAMIC_FORM_TYPES.MAIL_A_CHECK | DYNAMIC_FORM_TYPES.ACH_OUT | DYNAMIC_FORM_TYPES.ACH_OUT_MANDATORY | DYNAMIC_FORM_TYPES.BILL_PAY | DYNAMIC_FORM_TYPES.ACCOUNTANT;
export interface IProps {
    formType: formTypes;
    triggerFormSubmit: (formData:any) => void;
    triggerDelete: () => void;
    preFillData?: {};
    isEditMode?: boolean;
    isLoading?: boolean;
    isUpdateOnlyMode?: boolean;
    preFilledValue?: {inputId: string, value: string};
    shouldHideFooter?: boolean;
    shouldAvoidValidateAfterPreFill?: boolean;
    formValidationStatus?: (status: boolean) => void;
    onFormData?: (formData: any) => void;
}
